<div class="dialog-container green-theme">
    <div class="dialog-header">
      <h4 class="dialog-heading">Add New Season</h4>
      <button type="button" class="close-button" (click)="close()">
        <svg width="26px" height="24px" viewBox="0 0 26 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Nav-Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round"
            stroke-linejoin="round">
            <g id="Genre" transform="translate(-1438.000000, -32.000000)" class="inner-stroke" stroke="#FFFFFF">
              <g id="Genre-Options">
                <g id="Close" transform="translate(1439.000000, 32.000000)">
                  <path d="M24,0 L0,24" id="Path"></path>
                  <path d="M0,0 L24,24" id="Path"></path>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </button>
    </div>
  
    <mat-dialog-content>
      <!-- <app-loader *ngIf="loading" color="#50e3c2"></app-loader> -->
      <div class="dialog-body">
        <!-- <h3 class="title"><ng-container *ngFor="let season of show.seasons; let i = index;">{{season.title}}</ng-container></h3> -->
        <div class="grid-container">
            <div class="grid-item">
                {{ show.title }}
            </div>
        </div>
        <div class="grid-container">
            <div class="grid-item">
                <mat-form-field appearance="fill">
                    <mat-label>Season Number</mat-label>
                    <input matInput [(ngModel)]="seasonNumber">
                </mat-form-field>
            </div>
        </div>
        <div class="form-col buttons">
          <button class="form-button" (click)="createProSeason(show.id, seasonNumber, null)">Add Season</button>
          <button class="form-button form-button-cancel" (click)="close()">Cancel</button>
          <!-- <button class="form-button form-button-cancel" (click)="close()">Cancel</button> -->
        </div>
      </div>
    </mat-dialog-content>
  </div>
  